import styled from 'styled-components'

export default styled.section`
  .home-buying-posts .inner header h2 {
    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      max-width: 15rem;
    }
  }

  .mortgage-calc {
    .content{
      @media (min-width: ${props => props.theme.breakpoints.desktopLarge}) {
        width: 900px;
      }
    }
  }

  .section-title {
    margin-top: 0;
    font-size: 1.5625rem;
  }

  .paragraph-section {
    padding-top: 5rem;
    @media (max-width: ${props => props.theme.breakpoints.tablet}) {
      padding-bottom: 1rem;
    }
  }

  .loan-section {
    padding-top: 5rem;
    @media (min-width: ${props => props.theme.breakpoints.desktopLarge}) {
      min-width: 33rem;
    }
    @media (max-width: ${props => props.theme.breakpoints.desktop}) {
      padding-top: 0;
    }
  }

  .email-subscribe {
    padding-bottom: 2.5rem;
  }

`;